import React from 'react';

export default function StagingRestricted() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#000',
      color: '#fff',
      textAlign: 'center',
      padding: '2rem',
    }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>
        Staging Environment
      </h1>
      <h2 style={{ fontSize: '1.2rem', color: '#FFE43C', marginBottom: '1.5rem' }}>
        Access Restricted
      </h2>
      <p style={{ maxWidth: '400px', lineHeight: '1.6', color: '#ccc' }}>
        This staging environment is restricted to admin and moderator users only.
        If you believe you should have access, please contact the Siki team.
      </p>
      <a
        href="/"
        style={{
          marginTop: '2rem',
          padding: '0.75rem 2rem',
          backgroundColor: '#FFE43C',
          color: '#000',
          borderRadius: '8px',
          textDecoration: 'none',
          fontWeight: 'bold',
        }}
      >
        Return to Login
      </a>
    </div>
  );
}
